import { render, staticRenderFns } from "./OsobaTvrtkaCreate.vue?vue&type=template&id=49508e96&scoped=true&"
import script from "./OsobaTvrtkaCreate.vue?vue&type=script&lang=js&"
export * from "./OsobaTvrtkaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49508e96",
  null
  
)

export default component.exports